import { styled } from '@mui/system';
import { Box, Table, TableBody, TableCell, TableRow } from '@mui/material';

// The principal parent of all the section, includes the table and the admin drawer
export const StyledContainer = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  transition: 'all 0.3s ease-in-out',
}));

// Table container, includes table headers, table body and footer
export const StyledContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minWidth: '1260px',
  height: '100%',
  gap: '.5rem', // applies space between filters and table
  padding: '0',
  transition: 'all 0.3s ease-in-out',
  backgroundColor: theme.palette.primary.main,
  flex: '1 1 100%',

  // Compress width when drawer is open to keep shifts visible
  '&.drawer-open': {
    width: '75%', // Reduce width to 75%
    flexShrink: 1, // Allow it to shrink
    minWidth: '945px', // 1260px * 0.75 = 945px

  },
}));

// Contains only the content of the table, header, body
export const StyledTable = styled(Table)(({ theme }) => ({
  width: '100%',
  height: '100%',
  borderRadius: '1rem',
  backgroundColor: theme.palette.background.paper,
  '& > *': {
    margin: '1rem 0',
  },
}));

// Container of the Unassigned and Assigned sections
export const StyledTableBody = styled(TableBody)(() => ({
  padding: '11px 8px',
  maxHeight: '60vh',
  overflowY: 'auto',
  display: 'block',
  '& > *:not(:last-child)': {
    marginBottom: '1rem',
  },
}));

export const StyledTableRow = styled(TableRow)(() => ({
  display: 'table',
  width: '100%',
  tableLayout: 'fixed',
}));

// Empty state container
export const EmptyStateContainer = styled(Box)(() => ({
  textAlign: 'center',
  padding: '12rem 0',
  width: '100%',
}));

// Loading spinner container
export const SpinnerContainer = styled(Box)(() => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '12rem 0',
}));

// Table cell for empty and loading states
export const StyledTableCellEmpty = styled(TableCell)(() => ({
  padding: 0,
  border: 'none',
  background: 'none',
}));
